import {
  nbProductsLabel,
  nbProductsLabelRevamped,
} from '@/domains/productDiscovery/Listings/components/nbProducts/translations';

export const getLabel = (count: number, revamp: boolean): string | string[] => {
  const isMax = count > 500;

  const translation = (
    revamp ? nbProductsLabelRevamped : nbProductsLabel
  ).format<string>({
    count: count ?? 0,
    isMax,
  });
  return translation;
};
